import { render } from "./equip.vue?vue&type=template&id=47c80dba&scoped=true"
import script from "./equip.vue?vue&type=script&lang=ts"
export * from "./equip.vue?vue&type=script&lang=ts"

import "./equip.vue?vue&type=style&index=0&id=47c80dba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47c80dba"

export default script